import { render } from "./noteSettings.vue?vue&type=template&id=d0285e78&scoped=true"
import script from "./noteSettings.vue?vue&type=script&lang=js"
export * from "./noteSettings.vue?vue&type=script&lang=js"

import "./noteSettings.vue?vue&type=style&index=0&id=d0285e78&lang=scss&scoped=true"

import exportComponent from "D:\\project\\cloud-api-web-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0285e78"]])

export default __exports__